module.exports = __webpack_public_path__ + "0a0d7d3064b2973fcaecef67caedcbf0.svg";